"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetch = require("./fetchExtensions");
var es6_promise_1 = require("es6-promise");
var FetchWithStandardErrorHandling = /** @class */ (function () {
    function FetchWithStandardErrorHandling(props) {
        var getCsrfInfo = props.getCsrfInfo, errorHandlers = __rest(props, ["getCsrfInfo"]);
        this.getCsrfInfo = getCsrfInfo;
        this.errorHandlers = errorHandlers;
    }
    FetchWithStandardErrorHandling.prototype.getJson = function (url, concurrencyContext) {
        if (concurrencyContext) {
            return concurrencyContext.thenForLastWithErrorHandling(fetch.getJson(url), this.errorHandlers)
                .then(function (result) {
                if (!result.wasCancelled) {
                    return result.result;
                }
                else {
                    /* note: this request was "cancelled" so we return a new promise for the result that we never resolve */
                    return new es6_promise_1.Promise(function (resolve) { });
                }
            });
        }
        else {
            return fetch.withStandardErrorHandling(fetch.getJson(url), this.errorHandlers);
        }
    };
    FetchWithStandardErrorHandling.prototype.getJsonWithData = function (url, data, concurrencyContext) {
        return this.getJson(fetch.urlWithData(url, data), concurrencyContext);
    };
    FetchWithStandardErrorHandling.prototype.postJson = function (url, data, concurrencyContext) {
        if (concurrencyContext) {
            return concurrencyContext.thenForLastWithErrorHandling(fetch.postJson(url, data, this.getCsrfInfo), this.errorHandlers).then(function (result) {
                if (!result.wasCancelled) {
                    return result.result;
                }
                else {
                    /* note: this request was "cancelled" so we return a new promise for the result that we never resolve */
                    return new es6_promise_1.Promise(function (resolve) { });
                }
            });
        }
        else {
            return fetch.withStandardErrorHandling(fetch.postJson(url, data, this.getCsrfInfo), this.errorHandlers);
        }
    };
    FetchWithStandardErrorHandling.prototype.postFormData = function (url, data) {
        return fetch.withStandardErrorHandling(fetch.postFormData(url, data, this.getCsrfInfo), this.errorHandlers);
    };
    return FetchWithStandardErrorHandling;
}());
exports.FetchWithStandardErrorHandling = FetchWithStandardErrorHandling;
